export const environment = {
  production: false,
  urlUsuarios: 'https://wih39cmyk8.execute-api.us-east-1.amazonaws.com/qa/desbloqueoCuenta',
  urlApiDesbloqueo: 'https://wih39cmyk8.execute-api.us-east-1.amazonaws.com/qa/desbloqueoCuenta',
  siteKey: '6LfrWmInAAAAAEWW68gdhAnS89F68TaKyF8ihLD5',
  version:'v.qa.1.0.5',
  apikey:'8U9ezbHvfw5G4FX0ZnXvnRE0z5KKN5C5XaEOCna5'
};
